import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonInput, INPUT_TYPES } from '@brg/ui';
import { useController, useFormContext } from 'react-hook-form';
import {
  getBilingualTitleSlot,
  getProjectTitleForUiLang,
  setProjectTitleByLang,
} from '../helpers';


interface PropsT {
  isCollectionVote?: boolean;
  disabled?: boolean;
  onChange?: (e: any) => void;
  placeholder?: string;
};

const ProjectTitleInput: FC<PropsT> = ({ isCollectionVote, disabled, onChange, ...props }) => {
  const { t, i18n: { language } } = useTranslation();
  const { getValues } = useFormContext();
  const { field: { value, onChange: formOnChange } } = useController({ name: 'title' });
  
  const isBilingual = getValues('isBilingual');
  const additionalContent = getValues('additionalContent');

  const projectTitle = useMemo(() => {
    const title = value || additionalContent?.title?.text;
    return title ? getProjectTitleForUiLang(title, language, isBilingual) : '';
  }, [value, additionalContent, language, isBilingual]);

  const handleChange = (e: any) => {
    const newValue = setProjectTitleByLang(isBilingual, value, language, e.target.value);
    formOnChange(newValue);
    onChange?.(e);
  };

  const maxLength = useMemo(() => isCollectionVote ? 35 : 150, [isCollectionVote]);

  const placeholder = useMemo(() => {
    if (!isBilingual || !value?.length) {
      return props?.placeholder || t('project_edit.title_placeholder');
    }
    const currentSlot = getBilingualTitleSlot(language);
    const otherSlot = currentSlot === 'en' ? 'ru' : 'en';
    const otherLanguageValue = value.find(
      (item: { lang?: string }) => (item.lang ?? '').toLowerCase().trim() === otherSlot
    )?.name;
    return otherLanguageValue || props?.placeholder || t('project_edit.title_placeholder');
  }, [language, value, props?.placeholder, t, isBilingual]);

  return (
    <CommonInput
      type={INPUT_TYPES.text}
      value={projectTitle || ''}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      disable={!!disabled}
      {...props}
    />
  );
};

export default ProjectTitleInput;
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonInput, INPUT_TYPES } from '@brg/ui';
import { useController, useFormContext } from 'react-hook-form';
import {
  getBilingualTitleSlot,
  getProjectTitleForUiLang,
  setProjectTitleByLang,
} from '../helpers';


interface PropsT {
  isCollectionVote?: boolean;
  disabled?: boolean;
  onChange?: (e: any) => void;
  placeholder?: string;
};

const ProjectTitleInput: FC<PropsT> = ({ isCollectionVote, disabled, onChange, ...props }) => {
  const { t, i18n: { language } } = useTranslation();
  const { getValues } = useFormContext();
  const { field: { value, onChange: formOnChange } } = useController({ name: 'title' });
  
  const isBilingual = getValues('isBilingual');
  const additionalContent = getValues('additionalContent');

  const projectTitle = useMemo(() => {
    const title = value || additionalContent?.title?.text;
    return title ? getProjectTitleForUiLang(title, language, isBilingual) : '';
  }, [value, additionalContent, language, isBilingual]);

  const handleChange = (e: any) => {
    const newValue = setProjectTitleByLang(isBilingual, value, language, e.target.value);
    formOnChange(newValue);
    onChange?.(e);
  };

  const maxLength = useMemo(() => isCollectionVote ? 35 : 150, [isCollectionVote]);

  const placeholder = useMemo(() => {
    if (!isBilingual || !value?.length) {
      return props?.placeholder || t('project_edit.title_placeholder');
    }
    const currentSlot = getBilingualTitleSlot(language);
    const otherSlot = currentSlot === 'en' ? 'ru' : 'en';
    const otherLanguageValue = value.find(
      (item: { lang?: string }) => (item.lang ?? '').toLowerCase().trim() === otherSlot
    )?.name;
    return otherLanguageValue || props?.placeholder || t('project_edit.title_placeholder');
  }, [language, value, props?.placeholder, t, isBilingual]);

  return (
    <CommonInput
      type={INPUT_TYPES.text}
      value={projectTitle || ''}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={maxLength}
      disable={!!disabled}
      {...props}
    />
  );
};

export default ProjectTitleInput;
